import { useEffect, useState } from "react";

import { useMutation } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router";

import { IResponseData, processRequest } from "@api/config";
import { verificationAPI } from "@api/verification";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";
import { ROUTES } from "@configs/routes";

let hasHandledVerificationRedirect = false;

export const useVerificationInfoQuery = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const query = useAuthQuery({
		queryKey: [QUERY_KEYS.VERIFICATION_INFO],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_VERIFICATION_INFO,
				request: (token) => verificationAPI.getVerificationInfoAsync({ token }),
			});

			return data;
		},
	});

	const verificationRequired = query.isSuccess && query.data?.verification_required === true;

	useEffect(() => {
		if (!verificationRequired || hasHandledVerificationRedirect) {
			return;
		}

		hasHandledVerificationRedirect = true;

		if (location.pathname === ROUTES.AGE_VERIFICATION) {
			return;
		}

		navigate(ROUTES.AGE_VERIFICATION);
	}, [location.pathname, navigate, verificationRequired]);

	return query;
};

export const useStartVerificationMutation = () => {
	const [isLoading, setIsLoading] = useState(false);

	const mutation = useMutation({
		mutationFn: async () => {
			await processRequest({
				prefix: API_PREFIXES.START_VERIFICATION,
				request: (token) => verificationAPI.startVerificationAsync({ token }),
			});
		},
		onMutate: () => {
			setIsLoading(true);
		},
		onError: () => {
			setIsLoading(false);
		},
	});
	return { isLoading, mutate: mutation.mutate, isError: mutation.isError, error: mutation.error as IResponseData };
};
